import type { GenericObject } from '@makemydeal/dr-platform-types';

export const getLoadPayloadFeatureToggles = (payload: GenericObject | undefined): GenericObject | undefined =>
    payload?.primaryOfferFeatureToggles
        ? { ...payload.primaryOfferFeatureToggles, ...payload.featureToggles }
        : payload?.featureToggles;
